import axios from "axios";
import { act } from "react-dom/test-utils";
import baseURL from "../../../utils/baseURL";
import {
  resetErrAction,
  resetSuccessAction,
} from "../globalActions/globalActions";
const { createAsyncThunk, createSlice } = require("@reduxjs/toolkit");

//initalsState
const initialState = {
  products: [],
  product: {},
  loading: false,
  error: null,
  isAdded: false,
  isUpdated: false,
  isDelete: false,
  relatedProducts: [],      
  relatedLoading: false, 
};

//create product action
export const createProductAction = createAsyncThunk(
  "product/create",
  async (formData, { rejectWithValue, getState, dispatch }) => {
    try {
      const token = getState()?.users?.userAuth?.userInfo?.token;
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      };
      
      // Optional: Log only summary to avoid duplicate logs
      //console.log("Sending product creation request with files");
      
      const { data } = await axios.post(`${baseURL}/products`, formData, config);
      //console.log("Backend response:", data);
      return data;
    } catch (error) {
      //console.error("Error in createProductAction:", error.response?.data || error.message);
      return rejectWithValue(error.response?.data || { message: error.message });
    }
  }
);

//UPDATE PRODUCT ACTION
export const updateProductAction = createAsyncThunk(
  "product/update",
  async (payload, { rejectWithValue, getState }) => {
    try {
      const { name, description, category, sizes, brand, style, price, totalQty, id, existingImages, newImageFiles } = payload
      const token = getState()?.users?.userAuth?.userInfo?.token

      const formData = new FormData()
      formData.append('name', name)
      formData.append('description', description)
      formData.append('category', category)
      formData.append('brand', brand)
      formData.append('sizes', sizes)
      formData.append('style', style)
      formData.append('price', price)
      formData.append('totalQty', totalQty)
      formData.append('country', payload.country || '');
      formData.append('abv', payload.abv || '');
      formData.append('existingImages', JSON.stringify(existingImages))

      newImageFiles.forEach((file) => {
        formData.append('images', file)
      })

      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data',
        },
      }

      const { data } = await axios.put(`${baseURL}/products/${id}/update`, formData, config)
      return data
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)

//fetch products action
export const fetchProductsAction = createAsyncThunk(
  "product/list",
  async ({ url }, { rejectWithValue, getState, dispatch }) => {
    //console.log(url);
    try {
      const token = getState()?.users?.userAuth?.userInfo?.token;
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };

      const { data } = await axios.get(`${url}`, config);
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

//fetch product action
export const fetchProductAction = createAsyncThunk(
  "product/details",
  async (productId, { rejectWithValue, getState, dispatch }) => {
    try {
      const token = getState()?.users?.userAuth?.userInfo?.token;
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };

      const { data } = await axios.get(
        `${baseURL}/products/${productId}`,
        config
      );
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

//fetch related products (same brand or style)
export const fetchRelatedProductsAction = createAsyncThunk(
  "product/related",
  async ({ url }, { rejectWithValue, getState }) => {
    try {
      const token = getState()?.users?.userAuth?.userInfo?.token;
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      const { data } = await axios.get(url, config);
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);


//DELETE product action
export const deleteProductAction = createAsyncThunk(
  "product/delete",
  async (productId, { rejectWithValue, getState }) => {
    try {
      const token = getState()?.users?.userAuth?.userInfo?.token;
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      const { data } = await axios.delete(`${baseURL}/products/${productId}/delete`, config);
      return { ...data, productId };
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);


//slice
const productSlice = createSlice({
  name: "products",
  initialState,
  extraReducers: (builder) => {
    //create
    builder.addCase(createProductAction.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(createProductAction.fulfilled, (state, action) => {
      state.loading = false;
      state.product = action.payload;
      state.isAdded = true;
    });
    builder.addCase(createProductAction.rejected, (state, action) => {
      state.loading = false;
      state.product = null;
      state.isAdded = false;
      state.error = action.payload;
    });
    //update
    builder.addCase(updateProductAction.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(updateProductAction.fulfilled, (state, action) => {
      state.loading = false;
      state.product = action.payload;
      state.isUpdated = true;
    });
    builder.addCase(updateProductAction.rejected, (state, action) => {
      state.loading = false;
      state.product = null;
      state.isUpdated = false;
      state.error = action.payload;
    });
    //fetch all products
    builder.addCase(fetchProductsAction.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchProductsAction.fulfilled, (state, action) => {
      state.loading = false;
      state.products = action.payload;
      
    });
    builder.addCase(fetchProductsAction.rejected, (state, action) => {
      state.loading = false;
      state.products = null;
      state.isAdded = false;
      state.error = action.payload;
    });
    //fetch single
    builder.addCase(fetchProductAction.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchProductAction.fulfilled, (state, action) => {
      state.loading = false;
      state.product = action.payload;
   
    });
    builder.addCase(fetchProductAction.rejected, (state, action) => {
      state.loading = false;
      state.product = null;
      state.isAdded = false;
      state.error = action.payload;
    });
    //fetch related products
        builder.addCase(fetchRelatedProductsAction.pending, (state) => {
          state.relatedLoading = true;
        });
        builder.addCase(fetchRelatedProductsAction.fulfilled, (state, action) => {
          state.relatedLoading = false;
          state.relatedProducts = action.payload;
        });
        builder.addCase(fetchRelatedProductsAction.rejected, (state, action) => {
          state.relatedLoading = false;
          state.relatedProducts = null;
        });
        // DELETE
        //delete product
        builder.addCase(deleteProductAction.pending, (state) => {
          state.loading = true;
        });
        builder.addCase(deleteProductAction.fulfilled, (state, action) => {
          state.loading = false;
          // Quita el producto eliminado de la lista sin necesidad de re-fetch
          if (state.products?.products) {
            state.products.products = state.products.products.filter(
              (p) => p._id !== action.payload.productId
            );
          }
        });
        builder.addCase(deleteProductAction.rejected, (state, action) => {
          state.loading = false;
          state.error = action.payload;
        });
    //reset error
    builder.addCase(resetErrAction.pending, (state, action) => {
      state.error = null;
    });
    //reset success
    builder.addCase(resetSuccessAction.pending, (state, action) => {
      state.isAdded = false;
      state.isUpdated = false;
    });
  },
});

//generate the reducer
const productReducer = productSlice.reducer;

export default productReducer;